import { APPComponent } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/APPComponent';
import { EnumComponentType } from '../../../../../../api/com/MetaPattern/MDA/MD/Base/EnumComponentType';

export class APPComponentExtend {
  public static Init(dto: APPComponent) {
    dto.componentType = EnumComponentType.APP;
  }
}
